import { InputAdornment, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

export const NumberInput = ({
  name,
  label,
  pattern,
  required = false,
  helper = {},
  disabled = false,
  helperText,
  suffix,
  sx = {},
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={{ required, pattern, min: 0 }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          disabled={disabled}
          onChange={(event) => {
            field.onChange(
              !!event.target.value ? Number(event.target.value) : null
            );
          }}
          fullWidth
          id={name}
          label={label}
          required={required}
          error={error !== undefined}
          value={field.value?.toString() ?? ""}
          type={"number"}
          helperText={
            error ? (
              helper?.[name]?.[error.type] ? (
                helper?.[name]?.[error.type]
              ) : (
                <FormattedMessage
                  id={`common.${error.type}`}
                  values={{ field: label }}
                />
              )
            ) : (
              helperText ?? ""
            )
          }
          InputProps={{
            endAdornment: suffix ? (
              <InputAdornment position="end">{suffix}</InputAdornment>
            ) : null,
          }}
          sx={sx}
        />
      )}
    />
  );
};
